export default __webpack_public_path__ + "static/media/477.272e7402.jpg";